import { Link } from 'react-router-dom';

import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolderRounded';
import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded';
import NoteAddIcon from '@mui/icons-material/PostAdd';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import { addNodeUnderParent, removeNodeAtPath } from '@nosferatu500/react-sortable-tree';
import { PropTypes } from 'prop-types';
import { getNodeKey } from './helper';
import { useSnackbar } from 'notistack';

import './tree.scss';
import AlertDialog from 'views/common/AlertDialog';
import { useState } from 'react';

const iconButtonSx = { padding: '2px', color: '#616161', '&:hover': { color: '#000' } };

export const FolderBtn = ({ path, navTreeData, updateTreeDataFn }) => {
    const addNodeUnderParentRes = () => {
        const node = addNodeUnderParent({
            treeData: navTreeData,
            parentKey: path[path.length - 1],
            expandParent: true,
            getNodeKey,
            newNode: {
                title: '',
                edit: true,
                isDirectory: true,
                id: String(Date.now()),
                expanded: false,
                children: []
            },
            addAsFirstChild: false
        });

        return node.treeData;
    };

    return (
        <Tooltip title="Add folder">
            <IconButton size="small" aria-label="Add folder" sx={iconButtonSx} onClick={() => updateTreeDataFn(addNodeUnderParentRes())}>
                <CreateNewFolderIcon fontSize="small" />
            </IconButton>
        </Tooltip>
    );
};

const FileBtn = ({ updateNewTypeNode }) => (
    <Tooltip title="Add type">
        <IconButton size="small" aria-label="Add type" sx={iconButtonSx} component={Link} to="create-type" onClick={updateNewTypeNode}>
            <NoteAddIcon fontSize="small" />
        </IconButton>
    </Tooltip>
);

export const DeleteFolder = ({ node, path, navTreeData, updateTreeDataFn }) => {
    const { enqueueSnackbar } = useSnackbar();

    const deleteNodeRes = () => {
        if (node.children.length === 0) {
            const updatedTreeData = removeNodeAtPath({
                treeData: navTreeData,
                path,
                getNodeKey
            });

            return updatedTreeData;
        }

        enqueueSnackbar('Folder should be empty to be deleted', {
            variant: 'error'
        });
        return navTreeData;
    };

    return (
        <Tooltip title="Delete folder">
            <IconButton size="small" aria-label="Delete folder" sx={iconButtonSx} onClick={() => updateTreeDataFn(deleteNodeRes(), true)}>
                <DeleteForeverRoundedIcon fontSize="small" />
            </IconButton>
        </Tooltip>
    );
};

export const DeleteFile = ({ node, path, navTreeData, updateTreeDataFn, archivedTypeFn }) => {
    const [dialogStatus, setDialogStatus] = useState(false);

    const deleteNodeRes = () => {
        const updatedTreeData = removeNodeAtPath({
            treeData: navTreeData,
            path,
            getNodeKey
        });

        return updatedTreeData;
    };

    return (
        <>
            <AlertDialog
                dialogStatus={dialogStatus}
                title="Are you sure ?"
                description="It will move instance to archived."
                handleClickDisagree={() => setDialogStatus(false)}
                handleClickAgree={() => {
                    updateTreeDataFn(deleteNodeRes(), true);
                    archivedTypeFn(node);
                    setDialogStatus(false);
                }}
            />
            <Tooltip title="Archive type">
                <IconButton size="small" aria-label="Archive type" sx={iconButtonSx} onClick={() => setDialogStatus(true)}>
                    <DeleteForeverRoundedIcon fontSize="small" />
                </IconButton>
            </Tooltip>
        </>
    );
};

// Action Icon Add Folder & Add File
export const actionButton = (rowInfo, navTreeData, updateTreeDataFn, updateNewTypeNode, archivedTypeFn, isRootAdmin) => {
    if (rowInfo.node.edit || !isRootAdmin) {
        return [];
    }
    if (rowInfo.node.isDirectory) {
        return [
            <FolderBtn key="add-folder" navTreeData={navTreeData} path={rowInfo.path} updateTreeDataFn={updateTreeDataFn} />,
            <FileBtn key="add-file" updateNewTypeNode={() => updateNewTypeNode(rowInfo)} />,
            <DeleteFolder
                key="delete-folder"
                node={rowInfo.node}
                navTreeData={navTreeData}
                path={rowInfo.path}
                updateTreeDataFn={updateTreeDataFn}
            />
        ];
    }
    return [
        <DeleteFile
            key="delete-file"
            node={rowInfo.node}
            navTreeData={navTreeData}
            path={rowInfo.path}
            updateTreeDataFn={updateTreeDataFn}
            archivedTypeFn={archivedTypeFn}
        />
    ];
};

FolderBtn.propTypes = {
    path: PropTypes.array,
    navTreeData: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    updateTreeDataFn: PropTypes.func.isRequired,
    node: PropTypes.shape({})
};

FileBtn.propTypes = {
    updateNewTypeNode: PropTypes.func.isRequired
};

DeleteFolder.propTypes = {
    node: PropTypes.shape({ children: PropTypes.array }),
    path: PropTypes.array,
    navTreeData: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    updateTreeDataFn: PropTypes.func.isRequired
};

DeleteFile.propTypes = {
    node: PropTypes.shape({}),
    path: PropTypes.array,
    navTreeData: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    updateTreeDataFn: PropTypes.func.isRequired,
    archivedTypeFn: PropTypes.func
};
